/*89209 copiati ed incollati da cp.common per ovviare all'import in bulk di tutto il cp.comoon dalle public.api.ts
 * che porta alla rottura degli specs negli afterall*/
export type JsonPrimitive = null | boolean | number | string | JsonPrimitive[];
export type JsonObject = { [prop: string]: Json };
export type Json = JsonPrimitive | JsonObject | Json[];

export interface IDisabledConfig {
    placeholders: string[];
    formula: string;
}

export enum EIntegrationType {
    'BUTTON' = 'BUTTON',
    'ON_CALL' = 'ON_CALL',
}

export type PairingTokenBundle = {
    access_token: string,
    expires_in: number,
    refresh_token: string,
    id_token: string
};

export interface IRefreshTokenData {
    actionId: string;
    refreshUri: string;
    cacheKey: string; //dove salvare il risultato della chiamata di refresh token da configurare in modo che sia richiamabile nelle calls di  type button
    cacheInitialValue: PairingTokenBundle; //valore da iniettare alla chiamata se necessario
    isReset: boolean; //se true chiede di resettare il setinterval della chiamata di refresh token
}

/*type guard*/
export const isRefreshTokenData = (data: any): data is IRefreshTokenData =>
    data && typeof data === 'object' && data.actionId && data.refreshUri && data.cacheKey;

export type EAvailableActions = 'REFRESH_TOKEN';

export type AvailableActionDataType = IRefreshTokenData;

export interface IOnCallActionData {
    action: EAvailableActions;
    data: AvailableActionDataType;
}

export interface IExternalIntegration {
    id: string;
    type: EIntegrationType;
    label: string;
    description: string;
    where: EWhere;
    calls: IExternalIntegrationCall[];
    debug: boolean;
    disabled?: IDisabledConfig;
    alwaysEnabled?: boolean;
    position?: number; //se manca di default va in fondo se -1/negativo/Infinity va comunque in fondo
    /*parametri per ON_CALL type*/
    action: EAvailableActions; //action da chiamare internamente es REFRESH_TOKEN
    /*ciascun action name deve corrispondere ad un metodo private del servizio
che viene chiamato esternamente tramite .next su behaviourSubject
essendo una gestione oncall interna ai moduli ts estensa non ci sono problematiche di sicurezza
nel lasciare tale parte del json di configurazione nella cartella /assets
le uri se presenti vengono iniettate in esecuzione dal servizio chiamante e nessuna routine viene chiamata direttamente
ma solo scatenando un'osservabile con i parametri corretti (vedi IRefreshTokenData come esempio per gestire il refresh token sso )
*/
    test?: boolean;//se true viene usato fetch al posto di angular http cosi da evitare problemi di cors testando in locale
}

export enum EOperator {
    'GREATER' = 'GREATER',
    'EQUAL' = 'EQUAL',
    'GREATER_EQUAL' = 'GREATER_EQUAL',
    'LESS' = 'LESS',
    'LESS_EQUAL' = 'LESS_EQUAL',
    'NOT_EQUAL' = 'NOT_EQUAL',
}

export interface IErrorManagement {
    path: string; //path relativo all'oggetto ricevuto dalla chiamata rest non a tutto il datastore
    operator: EOperator;
    valueTrigger: string;
    action: EOnError;
    message: string;
}

export interface IFindConfig {
    keyPathToSearch: string;
    valueToMatch: string;
    arrayToSearchIn: any[];
}

export type InputEntryConfig = {
    name: string;// l'output del form andra nel datastore al path specificato nel target ed avra come prop i nomi degli inputs
    label: string;
    sourceDataPath: string; //path relativo al datastore corrente da usare per select e multi-select
    optionIdPath: string; //path interno ad ogni oggetto di sourceDataPath relativo all'id da usare come value nelle option
    optionLabelPath: string;// path interno ad ogni oggetto di sourceDataPath relativo al label da mostrare nelle option
    sourceData: any[];
    inputType: 'select' | 'multi-select' | 'number' | 'text' | 'boolean' | 'date';
    nonNullable: boolean;
    required: boolean;
    initialValue?: any;
}

export interface IFormCallConfig {
    skipOnPreFill: boolean; //se tutti dati sono gia compilati da default value oppure select con singola opzione allora passare alla call successiva
    inputList: InputEntryConfig[];
}

export interface IExternalIntegrationCall {
    description: string;
    type: EExternalIntegrationCallType; // tipo di chiamata
    url?: string;
    httpMethod?: EHttpMethod;
    body?: string;
    placeholders: string[];
    cacheKey?: string; //chiave da utilizzare per la cache, per ogni chiamata controllare se c'e un dato presente in cache e scriverlo nel target. altrimenti procedere con il flusso normale
    target?: string; // dove inserire il risultato
    errorHandling?: IErrorManagement;
    headers?: Record<string, string>; //campi opzionali da aggiungere all'header htp
    findConfig?: IFindConfig;
    test?: boolean;
    formConfig?: IFormCallConfig;
}

export enum EExternalIntegrationCallType {
    REST_EXTERNAL = 'REST_EXTERNAL',
    REST_ESTENSA = 'REST_ESTENSA',
    MODAL_WINDOW_URL = 'MODAL_WINDOW_URL',
    FIND_IN_DATA = 'FIND_IN_DATA',
    TAB_WINDOW_URL = 'TAB_WINDOW_URL',
    CACHE_OP = 'CACHE_OP',
    FORM = 'FORM',
    ERROR = 'ERROR'
}

export enum EHttpMethod {
    GET = 'GET',
    POST = 'POST',
    DELETE = 'DELETE',
    PUT = 'PUT',
    PATCH = 'PATCH',
}

export enum EOnError {
    CONTINUE = 'CONTINUE',
    BREAK = 'BREAK',
}

/*riprendere i nomi delle pagine gia usati*/
export enum EWhere {
    CUSTOM_PAGE_CARDIOLOGY_VISIT = 'CUSTOM_PAGE_CARDIOLOGY_VISIT',
    CUSTOM_PAGE_TELECONSULTATION = 'CUSTOM_PAGE_TELECONSULTATION',
    CUSTOM_PAGE_TELEMONITORING_VISIT = 'CUSTOM_PAGE_TELEMONITORING_VISIT',
    CUSTOM_PAGE_ULTRASOUND = 'CUSTOM_PAGE_ULTRASOUND',
    LIST_PAGE_VISIT = 'LIST_PAGE_VISIT',
    LIST_PAGE_ECG = 'LIST_PAGE_ECG',
    LIST_PAGE_COMPLETE_CD = 'LIST_PAGE_COMPLETE_CD',
    LIST_PAGE_COLLABORATION = 'LIST_PAGE_COLLABORATION',
    LIST_PAGE_ON_PRINTING_CD = 'LIST_PAGE_ON_PRINTING_CD',
    LIST_PAGE_TELEMONITORING = 'LIST_PAGE_TELEMONITORING',
    LIST_PAGE_NRE = 'LIST_PAGE_NRE',
    LIST_PAGE_SPECIALTY = 'LIST_PAGE_SPECIALTY',
}


export type FullIntegrationStoreData = Record<string, Json>;
